import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class SaveButton extends Component {
  constructor(props) {
    super(props);
    this.handleSaveClick = this.handleSaveClick.bind(this);
  }

  handleSaveClick() {
    const {dealer, agency, orders} = this.props;

    if (!orders.length) {
      this.props.addMessageBoxError('Por favor agregue elementos al pedido antes de continuar.');
      return;
    }

    this.props.createDealerSpecialOrder({dealer, agency, orders});
  }

  render() {
    const {loading, loadingReasons} = this.props;

    return (
      <Button primary
        type='button'
        content='GUARDAR'
        disabled={loading || loadingReasons}
        onClick={this.handleSaveClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'dealer': state.session.dealerId,
    'agency': state.session.dealerAgency,
    'loading': state.dealerSpecialOrders.loading,
    'loadingReasons': state.dealerSpecialOrders.loadingReasons,
    'orders': state.dealerSpecialOrders.list,
  };
};

const {
  addMessageBoxError,
  createDealerSpecialOrder,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  createDealerSpecialOrder,
})(SaveButton);
